/**
 * Locale-free date utility helpers.
 *
 * For locale-aware formatting (Today/Yesterday/Tomorrow labels, localized
 * month names, etc.) use `useDateFormatters` from this directory instead.
 */

export class DateUtils {
  /**
   * Format a Date for `<input type="datetime-local">`: "YYYY-MM-DDTHH:MM".
   */
  static toDatetimeLocalString(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  static timeInMinutesSecondsMillisFormat(date: Date): string {
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const millis = date.getMilliseconds().toString().padStart(3, '0');
    return `${minutes}:${seconds}:${millis}`;
  }
}
